import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { subscribe } from '@1inch-community/core/lit-utils';
import { BigFloat } from '@1inch-community/core/math';
import '@1inch-community/ui-components/loaders';
import '@1inch-community/ui-components/number-animation';
import { Task } from '@lit/task';
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { tap } from 'rxjs';
import { tooltip } from '../../tooltip';
import { tokenBalanceStyle } from '../style/token-balance.style';
let TokenFiatBalanceElement = class TokenFiatBalanceElement extends LitElement {
    constructor() {
        super(...arguments);
        this.endTextAlign = false;
        this.animateTransition = true;
        this.skeletonAnimationDelayMillisecond = 0;
        this.isConnectedWallet = true;
        this.applicationContext = lazyAppContextConsumer(this);
        this.task = new Task(this, async ([tokenId, symbol, chainIds, walletAddress]) => {
            if (this.value) {
                return this.value;
            }
            if (!this.isConnectedWallet) {
                return BigFloat.zero();
            }
            if (tokenId && walletAddress) {
                return await this.applicationContext.value.tokenStorage.getTokenFiatBalanceById({
                    tokenRecordId: tokenId,
                    walletAddress,
                });
            }
            if (symbol && chainIds && walletAddress) {
                return await this.applicationContext.value.tokenStorage.getTotalTokenFiatBalanceBySymbol({
                    chainIds,
                    symbol,
                    walletAddress,
                });
            }
            throw new Error('');
        }, () => [this.tokenId, this.symbol, this.chainIds, this.walletAddress]);
    }
    static { this.tagName = 'inch-token-fiat-balance'; }
    static { this.styles = tokenBalanceStyle; }
    firstUpdated() {
        if (this.value) {
            return;
        }
        subscribe(this, [
            this.applicationContext.value.onChain.crossChainEmitter.pipe(tap(() => this.task.run([this.tokenId, this.symbol, this.chainIds, this.walletAddress]))),
            this.applicationContext.value.wallet.data.isConnected$.pipe(tap((state) => (this.isConnectedWallet = state))),
        ], { requestUpdate: false });
    }
    render() {
        return this.task.render({
            error: () => this.renderBalanceOrLoader(),
            pending: () => this.renderBalanceOrLoader(),
            complete: () => this.renderBalanceOrLoader(),
        });
    }
    renderBalanceOrLoader() {
        if (!this.task.value)
            return this.renderLoader();
        return this.renderBalance(this.task.value);
    }
    renderBalance(balance) {
        if (this.animateTransition) {
            const style = {
                justifyContent: this.endTextAlign ? 'end' : '',
            };
            return html `
        <inch-number-animation
          ${tooltip(`$${balance.toFixedSmart(9)}`)}
          style="${styleMap(style)}"
          .value="${balance.toFixedSmart(2)}"
          prefixSymbol="$"
        ></inch-number-animation>
      `;
        }
        return html `<span ${tooltip({ text: `$${balance.toFixedSmart(9)}` })}
      >$${balance.toFixedSmart(2)}</span
    >`;
    }
    renderLoader() {
        const style = {
            marginLeft: this.endTextAlign ? 'auto' : '',
        };
        return html `<inch-loader-skeleton
      style="${styleMap(style)}"
      .animationDelayMillisecond="${this.skeletonAnimationDelayMillisecond}"
    ></inch-loader-skeleton>`;
    }
};
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", Object)
], TokenFiatBalanceElement.prototype, "value", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenFiatBalanceElement.prototype, "tokenId", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenFiatBalanceElement.prototype, "symbol", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", Array)
], TokenFiatBalanceElement.prototype, "chainIds", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenFiatBalanceElement.prototype, "walletAddress", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], TokenFiatBalanceElement.prototype, "endTextAlign", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], TokenFiatBalanceElement.prototype, "animateTransition", void 0);
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Number)
], TokenFiatBalanceElement.prototype, "skeletonAnimationDelayMillisecond", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], TokenFiatBalanceElement.prototype, "isConnectedWallet", void 0);
TokenFiatBalanceElement = __decorate([
    customElement(TokenFiatBalanceElement.tagName)
], TokenFiatBalanceElement);
export { TokenFiatBalanceElement };
//# sourceMappingURL=token-fiat-balance.element.js.map